import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getOrgUsers } from "../../../../service/endpoints";

export const AllUserHandler = createAsyncThunk('AllUserHandler', async () => {
  try {
    const response = await getOrgUsers();
    console.log(response.data, 'users');
    return response.data;


  } catch (error) {
    if (error.response !== undefined) {
      console.log('fail', error);
      throw error.response;
    } else
    {
      console.log(error);
      throw error.response;
    }
  }
});


const AllUserSlice = createSlice({
  name: 'get_users',
  initialState: {
    isLoading: false,
    data: null,
    isError: false
  },
  extraReducers: (builder) => {
    builder.addCase(AllUserHandler.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(AllUserHandler.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(AllUserHandler.rejected, (state, action) => {
      console.log(action.state);
      state.isError = true;
      console.log(action.payload);

    });
  }

});

export default AllUserSlice.reducer;